var earnWayCounter = 0;
var maxAttempts = 10;

function LoyaltyEarnWayTranslate() {
  const loyaltyEle = document.querySelector('#rivo-ways-to-earn');
  
  if (loyaltyEle) {
    const loyalty_point_purchases = loyaltyEle.querySelector('.rivo-points-purchases');
    const computedStyle = window.getComputedStyle(loyalty_point_purchases);
    if(loyalty_point_purchases && computedStyle.display != 'none'){
      clearInterval(getLoyaltyInterval);
      updateLoyaltyTranslation(loyalty_point_purchases);
    } else {
      if (earnWayCounter >= maxAttempts) {
        clearInterval(getLoyaltyInterval);
      } else {
        earnWayCounter++;
        setTimeout(LoyaltyEarnWayTranslate, 500);
      }
    }
  }
} 

var getLoyaltyInterval = setInterval(LoyaltyEarnWayTranslate, 2000);

function updateLoyaltyTranslation(loyalty_point_purchases) {
  var update_index = 0;
  var current_locale = Shopify.locale;
  const closestMainWrapper = loyalty_point_purchases.closest('#rivo-ways-to-earn');
  if(closestMainWrapper){
    const title_description = closestMainWrapper.querySelector('.rivo-lp-section-subtitle');
    if(title_description){
      if(current_locale === 'fr'){
        title_description.textContent = window.loyalty_translation.french_translation.title_french;
      } else if(current_locale === 'it'){
        title_description.textContent = window.loyalty_translation.italian_translation.title_italian;
      }
    }
  }
  const all_inner_buttons = loyalty_point_purchases.querySelectorAll('button.rivo-card');
  all_inner_buttons.forEach((button, index) => {
    update_index++;
    const button_arrow_icon = button.querySelector('.rivo-arrow-icon');
    const button_heading = button.querySelector('.rivo-card-title');
    const button_description = button.querySelector('.rivo-card-description');
    if(current_locale === 'fr'){
      button_heading.textContent = window.loyalty_translation.french_translation[`heading_${update_index}`];
      button_description.innerHTML = window.loyalty_translation.french_translation[`subheading_${update_index}`];
    } else if(current_locale === 'it'){
      button_heading.textContent = window.loyalty_translation.italian_translation[`heading_${update_index}`];
      button_description.innerHTML = window.loyalty_translation.italian_translation[`subheading_${update_index}`];
    }
  });
}
